"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonTranscodable = exports.isMetadataFile = exports.safeGetNameTypeAndExt = exports.getNameTypeAndExt = exports.getClipTypeFromExt = exports.isPdf = exports.isRawPhoto = exports.isDocument = exports.isAnimatedType = exports.isVideoType = exports.isPhotoType = exports.isAudioType = exports.getName = exports.getExt = exports.FALLBACK_NAME = exports.FALLBACK_EXT = void 0;
const types_1 = require("@air/types");
const path_1 = require("path");
const exts_1 = require("./exts");
exports.FALLBACK_EXT = 'file';
exports.FALLBACK_NAME = '_untitled';
const DEFAULT_TYPE = types_1.ClipType.nonMedia;
/**
 *
 * @param path filepath to check
 * If there is no `.` in the last portion of `path`, or if there
 * are no `.` characters other than the first character of the basename of `path`
 * , `extname` returns an empty string
 */
const pathHasExt = (path) => (0, path_1.extname)(path) !== '';
/**
 * Gets the ext out of a path. That is, everything after the . or the string itself if no .
 */
const getExt = (pathOrExt) => {
    if (!pathOrExt) {
        throw new Error("Can't getExt on a falsy path");
    }
    return pathOrExt.split('.').pop(); // We know it will never be undefined
};
exports.getExt = getExt;
/**
 * Given a file path or file name get the name (without ext)
 */
const getName = (path) => {
    if (!path) {
        throw new Error("Can't getName on a falsy path");
    }
    return (0, path_1.basename)(path, (0, path_1.extname)(path));
};
exports.getName = getName;
const isType = (type) => (pathOrExt) => {
    if (!pathOrExt) {
        return false;
    }
    const { type: extType } = (0, exts_1.getExtData)((0, exports.getExt)(pathOrExt));
    return extType === type;
};
const isKind = (kind) => (pathOrExt) => {
    if (!pathOrExt) {
        return false;
    }
    const { kind: extKind } = (0, exts_1.getExtData)((0, exports.getExt)(pathOrExt));
    return extKind === kind;
};
const isMimeType = (mime) => (pathOrExt) => {
    if (!pathOrExt) {
        return false;
    }
    const { mime: extMime } = (0, exts_1.getExtData)((0, exports.getExt)(pathOrExt));
    return extMime === mime;
};
exports.isAudioType = isType(types_1.ClipType.audio);
exports.isPhotoType = isType(types_1.ClipType.photo);
exports.isVideoType = isType(types_1.ClipType.video);
exports.isAnimatedType = isType(types_1.ClipType.animated);
const isDocument = (pathOrExt) => isKind('document')(pathOrExt) || isKind('presentation')(pathOrExt);
exports.isDocument = isDocument;
exports.isRawPhoto = isMimeType('image/x-dcraw');
exports.isPdf = isKind('pdf');
const extTypes = [
    { check: exports.isPhotoType, extType: types_1.ClipType.photo },
    { check: exports.isAnimatedType, extType: types_1.ClipType.animated },
    { check: exports.isVideoType, extType: types_1.ClipType.video },
    { check: exports.isAudioType, extType: types_1.ClipType.audio },
];
const getClipTypeFromExt = (ext, importedName) => {
    const foundExtType = extTypes.find(({ check }) => check(ext));
    const isMetaDataFile = importedName && hasLeadingPeriod(importedName);
    return foundExtType && !isMetaDataFile ? foundExtType.extType : DEFAULT_TYPE;
};
exports.getClipTypeFromExt = getClipTypeFromExt;
/**
 * Given a file path or file name, splits it into the importedName (without ext), ext (without a dot) and
 * uses the ext to determine the type of the file.
 *
 * Currently used by imports.
 */
const getNameTypeAndExt = (path) => {
    if (!path || !path.includes('.')) {
        throw new Error(`Invalid path for getNameTypeAndExt: ${path}`);
    }
    const importedName = (0, exports.getName)(path);
    const ext = (0, exports.getExt)(path);
    // At this point should have already gone through checks that the file overall is valid
    const type = (0, exports.getClipTypeFromExt)(ext, importedName);
    return { ext, type, importedName };
};
exports.getNameTypeAndExt = getNameTypeAndExt;
/**
 * Wrapper around getNameTypeAndExt; fails quietly; returns clip info despite error
 *
 * (Given a file path or file name, splits it into the importedName (without ext), ext (without a dot) and
 * uses the ext to determine the type of the file.
 *
 * Currently used by imports)
 */
const safeGetNameTypeAndExt = (path) => {
    try {
        return (0, exports.getNameTypeAndExt)(path);
    }
    catch (error) {
        console.log(`Invalid path name detected pathName: ${path}; falling back to .${exports.FALLBACK_EXT} extension`);
        return {
            ext: exports.FALLBACK_EXT,
            type: types_1.ClipType.nonMedia,
            importedName: path === undefined ? exports.FALLBACK_NAME : path,
        };
    }
};
exports.safeGetNameTypeAndExt = safeGetNameTypeAndExt;
/**
 *
 * @param str path or filename
 * We consider files that start with `.` to be metadata files,
 *  e.g. .DS_STORE, ._DS1_1134
 * For now, we also consider files without an extension to be
 * metadata files that we want to filter out, e.g. Podfile, until we figure out
 * how we want to handle such files longer-term
 */
const hasLeadingPeriod = (str) => str[0] === '.';
const isMetadataFile = (str) => hasLeadingPeriod(str) || !pathHasExt(str);
exports.isMetadataFile = isMetadataFile;
const isNonTranscodable = (ext) => !(0, exts_1.getExtData)(ext).transcodable;
exports.isNonTranscodable = isNonTranscodable;
//# sourceMappingURL=path.js.map